<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b2cge4/tc-custom/9781459225107.jpg?1705766050682" alt="This image is the cover for the book Moonlight and Mistletoe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moonlight and Mistletoe
      </h1>
      <p class="bookDescription body article font2">
        <b>A sparkling Regency Christmas in a sleepy English village!</b><br/><br/>Guy Westrope, Earl of Buckland, was not a gentleman used to encountering opposition to his will. But the quick-witted, stubborn and delectable Miss Hester Lattimer was proving to be more than a match for him.<br/><br/>Local ghost stories would not scare Hester from her new houseespecially not at Christmas! Though her heart told her to trust the mysterious earl, she knew she had to be wary. Even if Guy was not behind the strange events, letting him get too close would inevitably reveal her scandalous past!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louise Allen
      </h2>
      
      <p class="authorDescription body article">Louise Allen has been immersing herself in history for as long as she can remember, finding landscapes and places evoke powerful images of the past. Venice, Burgundy &amp; the Greek islands are favourites. Louise lives on the Norfolk coast &amp; spends her spare time gardening, researching family history or travelling. Please visit Louise&#39;s website, www.louiseallenregency.com, her blog https://janeaustenslondon or find her on Twitter @LouiseRegency and on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c154fd8